// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3HcCy","disabled":"FileBtn_disabled__jyID1","warn":"FileBtn_warn__1e49R","fade":"FileBtn_fade__JGig8"};